import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Form, Input, DatePicker, TimePicker, Space, List, Upload, UploadFile } from 'antd';
import { UploadOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/es/table';
import { API_BASE_URL } from "../../../services/apiConfig";
import AuthService from "../../../services/auth.service";
import dayjs from "dayjs";

interface Reservation {
  key: string;
  title: string;
  content: string;
  sendDate: string;
  reservationTime: string;
  recipients: string[];
  attachments: string[];
  groupSeq: any;
}

interface ReservationManagementPageProps {
  clubSeq: number;
  memberid: any;
  modalVisible1: any;
}
type FileAttachment = {
  name: string;
  deleted: boolean;
};

const ReservationManagementPage: React.FC<ReservationManagementPageProps> = ({ clubSeq, memberid, modalVisible1 }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const [recipientsModalVisible, setRecipientsModalVisible] = useState(false);
  const [selectedRecipients, setSelectedRecipients] = useState<string[]>([]);
  const [fileListAdditional, setFileListAdditional] = useState<File[]>([]);
  const [lastdate, setlastdate] = useState<dayjs.Dayjs | null>(null); // Dayjs 형식으로 상태 정의

  const [addfileList, setaddFileList] = useState<UploadFile[]>([]);
  const [fileList, setFileList] = useState<FileAttachment[]>([]);
  const [fileList1, setFileList1] = useState<FileAttachment[]>([]);
  const [Qrlasttimetime, setQrlasttimetime] = useState('');

  const [schedulerdata, setSchedulerdata] = useState<Reservation[]>([]);
  const [deleteFlags, setDeleteFlags] = useState<boolean[]>([]);
  const [currentRecipients, setCurrentRecipients] = useState<string[]>([]);
  const [selectgroupseq, setselectgroupseq] = useState('');
  const [selectfilecount, setselectfilecount] = useState(0);

  useEffect(() => {
    fetchSchedulerDataAPI();
  }, [modalVisible1]);


  useEffect(() => {
    console.log("이슈어 " + memberid)
  }, [memberid]);
  

  const fetchSchedulerDataAPI = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/club/personal/message/scheduler/group/list/${clubSeq}?page=0&size=10&sort=group_seq,desc`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${AuthService.getRawToken()}`,
          },
        }
      );
      const data = await response.json();
      console.log("예약리스트 : " + JSON.stringify(data, null, 2))
      const reservations = data.data.content
        .filter((item: any) => item.receiverMemberId !== memberid)
        .map((item: any) => {
          let attachments: string[] = [];

          try {
            attachments = JSON.parse(item.originalFileName);
            console.log("파일정보 : " + JSON.parse(item.originalFileName))
          } catch (e) {
            attachments = [item.originalFileName];
          }

          const savedFileNames = item.savedFileName
            .slice(1, -1)
            .split(", ")
            .map((fileName: string) => fileName.trim());

          const downloadLinks = savedFileNames.map((fileName: string) => ({
            name: fileName,
            url: `${item.fileUrl}${fileName}`,
          }));

          return {
            key: item.messageSchedulerSeq ? item.messageSchedulerSeq.toString() : `key-${Math.random()}`,
            title: item.title,
            content: item.message,
            sendDate: item.reservedDate.split('T')[0],
            reservationTime: item.reservedDate.split('T')[1],
            recipients: Array.isArray(item.receiverMemberNameArray) ? item.receiverMemberNameArray : [item.receiverMemberNameArray],
            attachments: attachments.length > 0 ? attachments.join(',').split(',') : [''],
            downloadLinks: downloadLinks,
            originalFileName: item.originalFileName,
            groupSeq: item.groupSeq,
          };
        });


      setSchedulerdata(reservations); // 예약 데이터 상태 업데이트
    } catch (error) {
      console.error("(ExcelUpload) Error fetching data:", error);
    }
  };

  const handleEdit = (record: Reservation) => {
    setselectgroupseq(record.groupSeq);
    setEditingKey(record.key);
    form.setFieldsValue({
      title: record.title,
      content: record.content,
      sendDate: dayjs(record.sendDate, 'YYYY-MM-DD'),
      reservationTime: dayjs(record.reservationTime, 'HH:mm'),
    });
    setCurrentRecipients(record.recipients);
    console.log("@@@")
    console.log(record.attachments)

    console.log(record.attachments.length)

    const attachments = record.attachments.map((attachment) => ({
      name: attachment,
      deleted: false,
    }));
    console.log("초기 상태: ", attachments);


    if (record.attachments.length === 1 && record.attachments[0] === '') {
      setFileList([]);
      setFileList1([]);
      setDeleteFlags([]);
    } else {
      setFileList(attachments);
      setFileList1(attachments);
      setDeleteFlags(new Array(record.attachments.length).fill(false));
    }

    console.log(new Array(record.attachments.length).fill(false))
    

    showModal();
  };

  const { confirm } = Modal;

  const handleDelete = (record: Reservation) => {
    confirm({
      title: '예약된 메시지 삭제',
      icon: <ExclamationCircleOutlined />,
      content: '정말 삭제하시겠습니까?',
      okText: '삭제',
      okType: 'danger',
      cancelText: '취소',
      onOk() {
        fetch(`${API_BASE_URL}/club/personal/message/scheduler/delete/${clubSeq}/${record.groupSeq}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${AuthService.getRawToken()}`,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            fetchSchedulerDataAPI();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      },
      onCancel() {
        console.log('취소되었습니다.');
      },
    });
  };

  const handleToggleExpand = (recipients: string[]) => {
    setSelectedRecipients(recipients);
    setRecipientsModalVisible(true);
  };

  const renderRecipients = (recipients: string[]) => {
    if (recipients.length >= 5) {
      return (
        <>
          {recipients.slice(0, 5).join(', ')}
          <a onClick={() => handleToggleExpand(recipients)} style={{ marginLeft: 8 }}>
            ...전체보기
          </a>
        </>
      );
    }
    return recipients.join(', ');
  };

  const handleSchedulerEdit = async (values: { title: string; content: string; sendDate: dayjs.Dayjs; reservationTime: dayjs.Dayjs; groupSeq: any }) => {
    try {
      console.log("수정 클릭");
      console.log('수정된 내용:', values);
      const reservedDate = `${values.sendDate.format('YYYY-MM-DD')} ${values.reservationTime.format('HH:mm:ss')}`;

      const additionalData = {
        clubSeq: clubSeq,
        groupSeq: selectgroupseq,
        reservedDate: reservedDate,
        fileExistsArray: deleteFlags,
      };

      // Merge values with additional data
      const postData = {
        ...values,
        ...additionalData,
        title: values.title || "",
        message: values.content || "",
      };

      console.log("보내는 값:", postData);

      const formData = new FormData();
      formData.append("messageSchedulerDto", new Blob([JSON.stringify(postData)], { type: "application/json" }));
      console.log("추가 파일 개수 : " + fileListAdditional.length)
      if (selectfilecount > 0) {
        // 파일 리스트를 순회하며 FormData에 추가
        fileListAdditional.forEach((file: any) => {
          formData.append("files", file.originFileObj); // originFileObj를 직접 추가
        });
      } else {
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        const emptyFile = new File([emptyBlob], "empty_file");
        formData.append("files", emptyFile);
      }

      const response = await fetch(`${API_BASE_URL}/club/personal/message/scheduler/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${AuthService.getRawToken()}`,
        },
        body: formData,
      });

      if (response.ok) {
        console.log("수정 완료");
        handleModalCancel();
        fetchSchedulerDataAPI();
      } else {
        console.error("수정 실패:", response.statusText);
        // Handle failure case appropriately
      }
    } catch (error) {
      console.error("수정 처리 중 오류 발생:", error);
      // Handle errors during update process
    }
  };
  const handleFileDelete = (file: any, index: number) => {
    console.log("지운파일이름 : " + file.name.replace(/[\[\]]/g, ''))

    const index1 = fileList.findIndex((item) => item.name.replace(/[\[\]]/g, '') === file.name.replace(/[\[\]]/g, ''));

    if (index !== -1) {
      // 2. fileList에서 해당 인덱스의 파일 삭제 처리 (deleted 속성을 true로 변경)
      const updatedFileList = [...fileList];
      updatedFileList[index1] = {
        ...updatedFileList[index1],
        deleted: true,
      };
      setFileList(updatedFileList);
      console.log("업데이트 현황: ", updatedFileList);
      const deletedFlags = updatedFileList.map((file) => file.deleted);
      setDeleteFlags(deletedFlags)
    }


    const updatedFileList1 = fileList1.filter((item) => item.name.replace(/[\[\]]/g, '') !== file.name.replace(/[\[\]]/g, ''));
    setFileList1(updatedFileList1);


  };


  const handleFileUpload = (info: any) => {
    const filesToUpload = info.fileList.map((fileInfo: any) => ({
      uid: fileInfo.uid,
      name: fileInfo.name,
      status: fileInfo.status,
      url: fileInfo.url,
      size: fileInfo.size,
      type: fileInfo.type,
      originFileObj: fileInfo.originFileObj,
    }));
    setFileListAdditional(filesToUpload);
    setselectfilecount(filesToUpload.length);
    setaddFileList(filesToUpload); // UploadFile 타입으로 변환하여 addfileList에 저장
    console.log("추가된 파일 이름들:", filesToUpload.map((file: any) => file.name));
  };

  const handleTimeChange = (time: any, timeString: string) => {
    setQrlasttimetime(timeString); // qrlasttime 상태 업데이트
  };

  const columns: ColumnsType<Reservation> = [
    {
      title: '제목',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '내용',
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: '발송일',
      dataIndex: 'sendDate',
      key: 'sendDate',
    },
    {
      title: '예약 시간',
      dataIndex: 'reservationTime',
      key: 'reservationTime',
    },
    {
      title: '수신자 정보',
      dataIndex: 'recipients',
      key: 'recipients',
      render: (recipients: string[]) => renderRecipients(recipients),
    },
    {
      title: '첨부파일',
      dataIndex: 'downloadLinks',
      key: 'downloadLinks',
      render: (downloadLinks: { name: string, url: string }[], record: Reservation) => (
        <div>
          {record.attachments.map((fileName, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <a href={downloadLinks[index].url} target="_blank" rel="noopener noreferrer">
                {fileName.replace(/[\[\]]/g, '')}
              </a>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: '수정/삭제',
      key: 'action',
      render: (text, record: Reservation) => (
        <Space size="middle">
          <a onClick={() => handleEdit(record)} style={{ color: 'green' }}><EditOutlined /></a>
          <a onClick={() => handleDelete(record)} style={{ color: 'red' }}><DeleteOutlined /></a>
        </Space>
      ),
    },
  ];

  const handleModalCancel = () => {
    setModalVisible(false);
    setFileListAdditional([]); // 첨부파일 선택 목록 초기화
    setselectfilecount(0); // 선택된 파일 개수 초기화
    setaddFileList([]);

  };

  const showModal = () => {
    setModalVisible(true);
    setFileListAdditional([]); // 첨부파일 선택 목록 초기화
    setselectfilecount(0); // 선택된 파일 개수 초기화
    setaddFileList([]);
  };

  const handleRecipientsModalCancel = () => {
    setRecipientsModalVisible(false);
  };

  const onFinish = (values: { title: string; content: string; sendDate: dayjs.Dayjs; reservationTime: dayjs.Dayjs }) => {
    console.log('Received values:', values);
    console.log('Current file list:', fileList);
    setModalVisible(false);
  };

  const handleLastDateChange = (date: dayjs.Dayjs | null) => {
    setlastdate(date); // Dayjs 형식으로 변경된 날짜 상태 업데이트
  };

  return (
    <div>
      <Table columns={columns} dataSource={schedulerdata} />
      <Modal
        title="예약 메시지 수정"
        visible={modalVisible}
        onCancel={handleModalCancel}
        footer={null}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="title"
            label="제목"
            rules={[{ required: true, message: '제목을 입력하세요!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="content"
            label="내용"
            rules={[{ required: true, message: '내용을 입력하세요!' }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item name="sendDate" label="발송일" rules={[{ required: true, message: '발송일을 선택해주세요.' }]}>
            <DatePicker
              clearIcon
              placeholder="발송일"
              value={lastdate}
              onChange={(date) => handleLastDateChange(date ? dayjs(date) : null)}
              style={{ marginRight: "8px", width: "150px" }}
            />
          </Form.Item>
          <Form.Item name="reservationTime" label="예약 시간" rules={[{ required: true, message: '예약 시간을 선택해주세요.' }]}>
            <TimePicker
              changeOnBlur
              style={{ marginRight: "8px", width: "200px" }}
              value={dayjs(Qrlasttimetime, 'HH:mm')}
              format="HH:mm"
              onChange={handleTimeChange}

            />
          </Form.Item>
          <Form.Item label="첨부파일">
            <Upload
              beforeUpload={() => false}
              onChange={handleFileUpload}
              fileList={addfileList}

            >
              <Button icon={<UploadOutlined />}>파일 선택</Button>
            </Upload>
            <List
              dataSource={fileList1}
              renderItem={(file, index) => (
                <List.Item key={index}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <span>{file.name.replace(/[\[\]]/g, '')}</span>
                    <Button
                      type="text"
                      shape="circle"
                      icon={<CloseCircleOutlined />}
                      onClick={() => handleFileDelete(file, index)}
                      style={{ color: 'red' }}
                    />
                  </div>
                </List.Item>
              )}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" onClick={() => handleSchedulerEdit(form.getFieldsValue())}>
              저장
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="전체 수신자 목록"
        visible={recipientsModalVisible}
        onCancel={handleRecipientsModalCancel}
        footer={null}
      >
        <List
          dataSource={selectedRecipients}
          renderItem={item => <List.Item>{item}</List.Item>}
        />
      </Modal>
    </div>
  );
};

export default ReservationManagementPage;
